var pagination = {
	backwardText: "προηγούμενη σελίδα",
	forwardText: "επόμενη σελίδα",
	pageRangeText: "Σελίδα {current} από {total}",
	itemsPerPageText: "Στοιχεία ανά σελίδα",
	itemRangeText: "{start}-{end} από {total} στοιχεία",
	pageNumberText: "τρέχουσα σελίδα"
};
var searchPlaceholder = "Αναζήτηση...";
var elTranslations = {
	pagination: pagination,
	searchPlaceholder: searchPlaceholder
};

export { elTranslations as default, pagination, searchPlaceholder };
